import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { usuarioSelector } from '../../selectors/sessionSelector'
import { tiposContenidoSelector } from '../../selectors/contenidoSelector'
import * as contenidoActions from '../../reducers/ContenidoReducer/actions'
import ContenidoEditado from '../../components/Contenido/contenidoEditado'
import * as Notification from '../../components/Common/notification'
import { compress, calculateNewSize } from '../../components/Common/imageCompressor'
import moment from 'moment'
import _axios from '../../apiClient'

class ContenidoEditadoContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            idTipoContenidoSelected: this.props.dataContenido.tiposContenido && this.props.dataContenido.tipoContenidoSelected ? this.props.dataContenido.tipoContenidoSelected : undefined,
            usuarioCargado: false,
            tiposContenidoCargados: this.props.dataContenido.tiposContenido ? true : false,
            nombre: undefined,
            tipoContenidoSelected: this.props.dataContenido.tiposContenido ? this.props.dataContenido.tiposContenido.find(x => x.idTipoContenido === this.props.dataContenido.tipoContenidoSelected) : undefined,
            error: {},
            textoLargo: undefined,
            pathImg: undefined,
            currentFile: undefined,
            idContenido: undefined,
            fechaActivacion: undefined,
            fechaDesactivacion: undefined,
            datos: undefined,
        }        

        this.props.sagaGetTiposContenido()
    }

    componentDidUpdate = async () => {
        if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
            this.setState({usuarioCargado: true}, () => {
                if (this.props.usuario.idRol === 4) {
                    window.location.hash = '/Pedidos'
                }
            })
        }
        const idContenido = this.props.match.params.idContenido;
        if (!this.state.datos) {
            await _axios.get(`/api/Contenido/GetContenidoById?id=${idContenido}`)

            .then(response => {
                this.setState({datos: response.data})
            }
                )
            .catch((error) => {
              const data = error.response.data
              throw (data)
            })
        }
        if (this.state.datos && this.state.idContenido !== this.state.datos.idContenido) {
           if (this.state.datos.fechaActivacion && this.state.datos.fechaDesactivacion) { 
                const fecha1 = this.state.datos.fechaActivacion.split(' ')[0];
                const dia1 = fecha1.split('/')[0];
                const mes1 = fecha1.split('/')[1];
                const anio1 = fecha1.split('/')[2];
                const fecha2 = this.state.datos.fechaDesactivacion.split(' ')[0];
                const dia2 = fecha2.split('/')[0];
                const mes2 = fecha2.split('/')[1];
                const anio2 = fecha2.split('/')[2];
                this.setState({
                    fechaActivacion: moment(new Date(`${mes1}/${dia1}/${anio1}`)).format('YYYY-MM-DD'),
                    fechaDesactivacion: moment(new Date(`${mes2}/${dia2}/${anio2}`)).format('YYYY-MM-DD')
                })
            }
            this.setState({
                nombre: this.state.datos.textoCorto,
                idTipoContenidoSelected: this.state.datos.idTipoContenido,
                pathImg: this.state.datos.pathImagen,
                textoLargo: this.state.datos.textoLargo || '',
                idContenido: this.state.datos.idContenido,
                idTipoContenido: this.state.datos.idTipoContenido,
                tipoContenidoSelected: this.props.dataContenido.tiposContenido ? this.props.dataContenido.tiposContenido.find( x => x.idTipoContenido === this.state.datos.idTipoContenido) : null,
            })
        }
        localStorage.setItem('idTipoContenidoSelected', JSON.stringify({idTipoContenidoSelected:this.state.datos.idTipoContenido}));
    }
    
    handleOnClickDia = (fecha) => {
        this.setState(fecha)
    }

    handleOnChange = (e) => {
        let value = e.target.value
        let name = e.target.name
        
        let pathImg = this.state.pathImg
        let currentFile = this.state.currentFile

        if (name === "idTipoContenido") {
            let item = undefined
            if (this.props.dataContenido.tiposContenido) {
                item = this.props.dataContenido.tiposContenido.find( x => x.idTipoContenido === value)
            }

            this.setState({
                [name]: value, 
                tipoContenidoSelected: item,
                pathImg: pathImg,
                currentFile: currentFile,
                textoLargo: undefined
            })

            return
        }
        
        this.setState({
            [name]: value
        })
    }

    handleOnSave = () => {
        
        let error = {}
        let flag = false

        if(this.state.idTipoContenidoSelected === undefined){
            error.tipoContenido = "Seleccione un tipo de contenido"
            flag = true
        }
        
        if (this.state.tipoContenidoSelected && this.state.tipoContenidoSelected.nombre !== "Preguntas frecuentes") {
            if (this.state.nombre === undefined || this.state.nombre === "" || this.state.nombre === null) {
                error.nombre = "Ingrese un nombre para el contenido"
                flag = true
            }
            
            if (this.state.nombre !== undefined && this.state.nombre.length > 50) {
                error.nombre = "Longitud máxima es de 50 caracteres"
                flag = true
            }

            if ((this.state.idTipoContenidoSelected === 1 || this.state.idTipoContenidoSelected  === 2) && (this.state.pathImg == null)) {
                error.imagen = "Debe arrastrar o elegir una imagen"
                flag = true
            }

            if ((this.state.fechaActivacion === null) || (this.state.fechaDesactivacion === null)) {
                error.fecha = "Debe ingresar una fecha"
                flag = true
            }

            if (moment(this.state.fechaDesactivacion).isSameOrBefore(this.state.fechaActivacion)) {
                    error.fecha = "Debe ser mayor o igual a la fecha de inicio."
                    flag = true
            }

            }
                

        //agregar validacion de archivo subido
        this.setState({error: error}, () => {
            if (!flag) {
                let payload = {
                    idContenido: this.state.idContenido,
                    nombre: this.state.nombre,
                    file: this.state.currentFile,
                    textoLargo: this.state.textoLargo,
                    fechaActivacion: this.state.fechaActivacion,
                    fechaDesactivacion: this.state.fechaDesactivacion
                }

                payload.callback = () => {
                    window.location.hash = '/Contenido'
                }

                this.props.sagaPutContenido(payload)
            }
        })
    }

    handleOnDropFile = (acceptedFiles, rejectedFiles) => {
        if (rejectedFiles.length !== 0) {
            if (rejectedFiles.length === 1) Notification.showError("Formato de Imagen no aceptado.")
            if (rejectedFiles.length > 1) Notification.showError("Se permite solo una imagen como portada de catálogo.")
        } else {
            if (acceptedFiles.length !== 0) {
                
                let currentFile = acceptedFiles[0]

                if (currentFile.type === 'image/gif') {
                    // Si es un GIF no lo comprimo ni redimensiono
                    let file = URL.createObjectURL(currentFile)
                    this.setState({
                        pathImg: file,
                        currentFile: currentFile,
                        error: { ...this.state.error, imagen: '' }
                    });
                } else {
                    let tipoContenidoSelected = this.state.tipoContenidoSelected
    
                    // genero una imagen para conocer sus dimesiones
                    let _self = this
                    let img = new Image()
                    img.onload = function () {
                        
                        let width = this.width
                        let height = this.height
    
                        if(tipoContenidoSelected && tipoContenidoSelected.idTipoContenido === 1){
                            width = 1417
                            height = 222
                        }
    
                        if(tipoContenidoSelected && tipoContenidoSelected.idTipoContenido === 2){
                            width = 481
                            height = 627
                        }
    
                        // comprimo la imagen
                        let newSize = calculateNewSize(width, height, width*2, height*2)
                        compress(currentFile, currentFile.name, newSize.width, newSize.height, _self.onImageCompressed)
                    }
                    img.src = URL.createObjectURL(currentFile)
                }
            }
        }                
    }

    onImageCompressed = (currentFile) => {
        //guardo en el estado una copia, para usarla al momento de guardar los recortes
        let currentFileCopy = currentFile
        let file = URL.createObjectURL(currentFile)
        
        this.setState({
            pathImg: file,
            currentFile: currentFileCopy,
            error: {...this.state.error, imagen: ''} 
        })
    }

    render() {
        return (
             <ContenidoEditado 
                idTipoContenido={this.state.idTipoContenido}
                idContenido={this.state.idContenido}
                tiposContenido={this.props.dataContenido.tiposContenido}
                tipoContenidoSelected={this.state.tipoContenidoSelected}
                nombre={this.state.nombre}
                textoLargo={this.state.textoLargo}
                textoCorto={this.state.textoCorto}
                fechaActivacion={this.state.fechaActivacion}
                fechaDesactivacion={this.state.fechaDesactivacion}
                error={this.state.error}
                pathImg={this.state.pathImg}
                handleOnChange={this.handleOnChange}
                handleOnSave={this.handleOnSave}
                handleOnDropFile={this.handleOnDropFile}
                handleOnClickDia={this.handleOnClickDia}
             /> 
        )
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...contenidoActions
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        usuario: usuarioSelector(state),
        dataContenido: tiposContenidoSelector(state)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ContenidoEditadoContainer)